import { map } from 'lodash-es';

import * as angular from 'angular';

export interface PricingModelData {
  pricingModel: {
    id: number;
    name: string;
  };
  volumeRange: any;
  priceTypes: any;
  priceTypeDurations: any;
  isComplete: boolean;
}

// Same as buyers Profile
export interface Profile {
  address1: string;
  address2: string;
  city: string;
  gln: string;
  id: number;
  name: string;
  state: string;
  zip: string;
}

export default class SellersService {
  static $inject = ['$http'];

  baseUrl = '/aptitude/api/sellers/';

  constructor(private $http) {
    'ngInject';
  }

  getSellers(rfpId?: number, sellerType?: string, eligible?: boolean) {
    return this.$http.get(this.baseUrl, {
      params: {
        rfpId,
        sellerType,
        eligible
      }
    });
  }

  getPricingModels(
    sellerId: number,
    categoryId: number,
    rfpId: number
  ): ng.IPromise<any> {
    return this.$http
      .get(`${this.baseUrl}${sellerId}/pricingModels`, {
        params: {
          categoryId,
          rfpId
        }
      })
      .then(function (pricingModels) {
        return map(pricingModels.data, function (item: PricingModelData) {
          return {
            id: item.pricingModel.id,
            name: item.pricingModel.name,
            volumeDiscounts: item.volumeRange ? item.volumeRange : null,
            priceTypes: item.priceTypes,
            priceTypeDurations: item.priceTypeDurations,
            isComplete: item.isComplete
          };
        });
      });
  }

  createPricingModel(
    sellerId: number,
    categoryId: number,
    pricingModelName: string
  ): ng.IPromise<any> {
    return this.$http.post(`${this.baseUrl}${sellerId}/pricingModels`, {
      categoryId: categoryId,
      modelName: pricingModelName
    });
  }

  getCategories(sellerId: number, rfpId?: number) {
    return this.$http.get(`${this.baseUrl + sellerId}/categories`, {
      params: {
        rfpId
      }
    });
  }

  // TODO: This needs to go somewhere else
  getComparisons(
    requestId: number,
    pricingModelId: number,
    volumeDiscount: number
  ) {
    // TODO: Get this code using the HTTP interceptor.
    return this.$http.get(
      `/aptitude/seller/SellerPricingRequestServiceController/getComparisons`,
      {
        params: {
          requestId,
          pricingModelId,
          volumeDiscount
        }
      }
    );
  }
}
